<template>
    <div
      :data-id="`${item.product_id}`" 
      class="listing-item customise"
      :class="{ zoom: props.hover_zoom }"
      style="cursor: pointer"
    >

    
       <a :href="getLangUrlItem(`${props.item?.slug}?${paramString}`, baseUrl, locale)">
        <div class="listing-item__media">
              <div class="product-tags product-tags-customise" v-html="htmlSpecialcharsDecode(htmlTag)" ></div>
            
          <div class="sale_discoun-1" v-if="saleDiscount >= 5" >
                <img
                  src="/vc-02.svg"
                 />
                 <span>-{{ saleDiscount }}%</span>
              </div>
          <img v-if="!props.item"
            src="/default.gif"
            class="listing-item__media-image img1"/>
          <img
            v-if="currentCover !== ''"
            :src="currentCover !=='' ? currentCover : ''"
            :alt=" altImage !== '' ? altImage : ''"
            class="listing-item__media-image img"
          />
          <div
            :data-name = "htmlSpecialcharsDecode(props.item?.title)"
            :class="[
              props.whistlist !== false ? 'listing-item__wishlist' : '',
              { active: isActive }
            ]"
            @click="wishListItem($event, item.product_id)"
          ></div>
          <div class="icon-diamond-wrapper"
              @mouseenter="isSwatchVisible = true"
              @mouseleave="isSwatchVisible = false"
              @click="handleDiamondClick"
              v-if="props.customiseAtribute?.other_swatches && Object.keys(props.customiseAtribute?.other_swatches).length > 0"
          >
              <div class="icon-diamond">
                 <img :src="primaryGemstone" alt="primary Gemstone">
              </div>
              <div class="icon-diamond active">
                  <img :src="hoverGemstone" alt="Gemstone">
              </div>
              <div v-if="props.customiseAtribute?.other_swatches" class="swatch-other"   :class="{ 'show': isSwatchVisible }" >
                <template v-for="(swatch, swatchKey) in props.customiseAtribute.other_swatches" :key="swatchKey">
                  <div class="other-swatches-name">
                      {{ nameGemstone }}
                  </div>
                  <div v-if="swatch.items && Object.keys(swatch.items).length > 0" class="other-items">
                    <template  v-for="(item, itemKey) in getSortedItems(swatch.items)"  :key="itemKey">
                          <div
                            class="other-item"
                            :class="{ 'active': selectedIds[swatch.slug] === item.att_term_id }"
                            @click="handleSwatchClick($event , item.slug, item.att_term_id , swatch.slug , item.name)"
                          >
                            <div class="other-thumb">
                                  <img 
                                    v-if="`${baseUrl}api/wp-content/uploads/${item.thumb}`" 
                                    :src="`${baseUrl}api/wp-content/uploads/${item.thumb}`"
                                    :alt="item.name"
                                  />
                            </div>
                          </div>
                      </template>
                  </div>
                </template>
              </div>
          </div>
        </div>

        <div class="listing-item__info">
          <p class="listing-item__info-name" v-html = "htmlSpecialcharsDecode(props.item?.title)"></p>
            <p class="price-html">
              <span class="w_price" v-if="regularPrice != '0'">
                  <del v-if="regularPrice != '0' && Number(salePrice) > 0 && Number(regularPrice) > Number(salePrice)" >
                      <span class="woocommerce-Price-amount amount b99" v-html="displayCustomPrice(regularPrice)"></span>
                  </del>
                  <span v-if="Number(salePrice) > 0 ">
                    <span class="woocommerce-Price-amount amount b44" v-html="displayCustomPrice(salePrice)"></span>
                  </span>
                  <span v-else>
                    <span class="woocommerce-Price-amount amount" v-html="displayCustomPrice(regularPrice)"></span>
                  </span>
              </span>
              <span class="woocommerce-Price-amount amount" v-if="regularPrice == '0' " v-html="displayCustomPrice(salePrice)"></span>
            </p>
            <div v-if="props.customiseAtribute?.color_swatches && Object.keys(props.customiseAtribute?.color_swatches).length > 0" class="swatch-group">
              <template v-for="(swatch, swatchKey) in props.customiseAtribute.color_swatches" :key="swatchKey">
                <div v-if="swatch.items && Object.keys(swatch.items).length > 0" class="swatch-items">
                  <div 
                    v-for="(item, itemKey) in getSortedItems(swatch.items)" 
                    :key="itemKey"
                    class="swatch-item"
                     :class="{ 'active': selectedIds[swatch.slug] === item.att_term_id }"
                     @click="handleSwatchClick($event , item.slug, item.att_term_id , swatch.slug , item.name )"
                  >
                    <img 
                      v-if="`${baseUrl}api/wp-content/uploads/${item.thumb}`" 
                      :src="`${baseUrl}api/wp-content/uploads/${item.thumb}`"
                      :alt="item.name"
                      class="swatch-thumb"
                    />
                  </div>
                </div>
              </template>
            </div>
          <ProductShortTerm @is-teaser="handleTeaser" @short-term="handleShortTerm" :data="item.short_sale" v-if="item.short_sale && Object.keys(item.short_sale).length > 0" />
        </div>
      </a>
    </div>
</template>

  <script setup lang="ts">
import { ref } from "vue";
import type { CustomiseOption } from '~/types/product-listing'
import type { IProductItem } from "~/types/productItem";
import { displayCustomPrice } from '@/utils/displayPrice'
import { htmlSpecialcharsDecode } from '@/utils/helpers'
import type { IAPIResponseError } from '~/types/apiResponseError';
import ProductShortTerm from "./ProductShortTerm.vue";
import { useCustomGtm } from '~/composables/useEventTagManager';
import hoverGemstone from '~/assets/images/Hover-Gemstone-Icon.svg';
import primaryGemstone from '~/assets/images/Primary-Gemstone-Icon.svg';

const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
const wooStore = useWooStore();
const countryShort = wooStore.country?.country_short;

import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl, getLangUrlItem } from '~/utils/getLangUrl';

const userStore = useUserStore();
const type = ref<number>(1);
const background_color = ref('transparent');
const list_item_wishlist = ref<number[]>([]);
const { $ajax } = useNuxtApp();
//const htmlTag = ref('<span class="tag_detail customise_tag_detail">Customisable</span>');

const { trackAddWishList, trackRemoveWishList } = useCustomGtm();


const props = withDefaults(defineProps<{
  item: IProductItem;
  min_max?: boolean;
  whistlist?: boolean;
  hover_zoom?: boolean;
  background_item?: string;
  customiseAtribute : ICustomiseAttribute ;
  swatchesVariation : ISwatchesVariation ;
  customiseOption: CustomiseOption;
}>(), {
  whistlist: true,
  hover_zoom: false,
  min_max: false,
  background_item: 'transparent'
});

const htmlTag = computed(() => {
  let  html = '';

  const tags = props.item?.product_tag;
  //console.log('---- tags',tags)

  if (Array.isArray(tags)) {
    html += tags
      .map(tag => `<span class="tag_detail customise_tag_detail">${tag}</span>`)
      .join('');
  } else {
    html += tags;
  }

 

  return html;
});

interface IResponse {
  success: boolean;
  data: any[];
};

const isTeaser = ref(false);
const handleTeaser = () => {
  isTeaser.value = true;
}

const isActive = computed(() => list_item_wishlist.value.includes(Number(props.item.product_id)));


const handleShortTerm = (price: string) => {

  const saleDiscount: number = 100 - ( parseInt(salePrice.value) / parseInt(regularPrice.value) * 100);
  
  props.item.sale_discount = Math.round(saleDiscount).toString();
  props.item.sale_price = price;

}

const calculateDiscount = (salePrice: number, regularPrice: number): number => {
    const saleDiscount: number = 100 - (salePrice / regularPrice * 100);
    return Math.round(saleDiscount);
}

const getSortedItems = (items: Record<string, IItem>): IItem[] => {
  return Object.values(items).sort((a, b) => {
    return a.name.localeCompare(b.name);
  });
};

const wishListItem = async (event: any, id_item: Number) => {
    event.stopPropagation();
    event.preventDefault();
   
    const clickedElement = event.currentTarget as HTMLElement;
    const dataName = clickedElement.getAttribute('data-name');

    id_item = Number(id_item);
    like_item_wishlist(id_item);

    let list_wishlist = JSON.parse(localStorage.getItem('list_wishlist') || '[]');
    const itemIndex = list_wishlist.indexOf(id_item);
    if (itemIndex === -1) {
      if (typeof dataName === 'string' && dataName.trim() !== '') {
        trackAddWishList(dataName);
        if (typeof window.lxt !== 'undefined' && dataName) {
          window.lxt('track', 'products_added_to_wishlist', dataName);
        }
      }
        list_wishlist.push(id_item);
    } else {
      if (typeof dataName === 'string' && dataName.trim() !== '') {
        trackRemoveWishList(dataName);
        if (typeof window.lxt !== 'undefined' && dataName) {
          window.lxt('track', 'products_removed_from_wishlist', dataName);
        }
      }
      list_wishlist.splice(itemIndex, 1);
    }
    localStorage.setItem('list_wishlist', JSON.stringify(list_wishlist));
    isActive.value = !isActive.value;

    if(userStore.isLogin){
      let all_item_wishlist = JSON.parse(localStorage.getItem('all_item_wishlist') || 'null');
      const itemIndex = all_item_wishlist.indexOf(id_item);
      if (itemIndex === -1) {
        all_item_wishlist.push(id_item);
      } else {
        all_item_wishlist.splice(itemIndex, 1);
      }
      localStorage.setItem('all_item_wishlist', JSON.stringify(all_item_wishlist));
      list_item_wishlist.value = all_item_wishlist;
    }else{
      list_item_wishlist.value = list_wishlist;
    }
   
};

const like_item_wishlist = async(id_item: Number) => {
  try {
    const response = await $ajax.get<IResponse>(`wp-json/skj/v1/wishlist/like?id_item=${id_item}`,{ headers: {"Authorization": `Bearer ${userStore.csrf}`,'X-API-Server': userStore.csrf_server} });
    if(response.success){

    }
  }catch(error) {
      if (error && typeof error === 'object' && 'data' in error) {
          const errorData = error.data as IAPIResponseError;
      } else {
      }
  }
}

// wind ;

const currentCover = ref(props.item?.cover?.src || '');
const altImage = ref(props.item?.cover?.alt || '');
const salePrice = ref(props.item?.sale_price || '');
const regularPrice = ref(100);
const saleDiscount = ref(0);
const shortSale = ref({});

///
 const transformPriceData = (priceData: {
  sale_price: string,
  regular_price: string,
  short_term_price: string
}, dateData: {
  _sale_price_dates: { _date_from: string, _date_to: string },
  _short_term_dates: { _date_from: string, _date_to: string }
}) => {
  return {
    regular_price: Number(priceData.regular_price),
    short_term_price: Number(priceData.short_term_price),
    short_term_dates: dateData._short_term_dates,
    sale_price: priceData.sale_price,
    sale_price_dates: dateData._sale_price_dates,
    price: Number(priceData.regular_price)
  };
};

// Create reactive reference for activeItem
  const activeItem = ref({
    regular_price: '0',
    salePrice: '0',
    sale_price: '0',
    price: 0
  });
  if (props.item) {


    const shortSale = props.item?.short_sale || {}
    const date = {
      _short_term_dates: { _date_from: shortSale?.short?.date_from, _date_to: shortSale?.short?.date_end },
      _sale_price_dates: { _date_from: shortSale?.schedule?.date_from || '', _date_to: shortSale?.schedule?.date_end || '' }
    };
      const result = transformPriceData(
        {
          sale_price: props.item?.sale_price || '',
          regular_price: props.item?.regular_price || '',
          short_term_price: props.item?.short_sale?.short?.price || ''
        },
        date
      );
      activeItem.value = getPriceDataCustomise(result);
    
      // First, get the values directly without nested refs
      salePrice.value = activeItem.value?.sale_price || '0'
      regularPrice.value = activeItem.value?.regular_price || '0'

      // Convert string values to numbers before calculation
      const salePriceNum = Number(salePrice.value)
      const regularPriceNum = Number(regularPrice.value)

      // Calculate discount with numerical values
      // Using Math.floor() to round down to nearest integer
      if (salePriceNum > 0) {
      saleDiscount.value = Math.floor(((1 - salePriceNum / regularPriceNum) * 100))
      }

  }
  
///

const isSwatchVisible = ref(false);
const selectedVariation = ref<any>(null);

watch(()=> selectedVariation.value , () => {
  if (selectedVariation.value) {
    salePrice.value = selectedVariation.value?.sale_price ;
    regularPrice.value = selectedVariation.value?.regular_price ;
    currentCover.value = selectedVariation.value?.gallery ;
    altImage.value = selectedVariation.value?.alt ;
  }
});


const handleDiamondClick = (event: Event) => {

    event.stopPropagation();
    event.preventDefault();
    isSwatchVisible.value = !isSwatchVisible.value;
}

const selectedIds = ref<{ [key: string]: string }>({});
const arrayParam = ref<{ [key: string]: string }>({});
const paramString = ref<string>('');
const nameGemstone = ref<string>('');

const getVariationKey = (ids: string[]) => {
  return [...ids].sort((a, b) => parseInt(a) - parseInt(b)).join(',');
};

interface SwatchesVariation {
  id: string;
  gallery?: string;
  alt?: string;
  sale_price: string;
  regular_price: string;
  short_term_price: string;
}

interface ISwatchesVariation {
  [key: string]: SwatchesVariation;
}


const findVariation = () => {

  const ids = Object.values(selectedIds.value);
  const key = getVariationKey(ids);


  const queryString = new URLSearchParams(arrayParam.value).toString();
  paramString.value = '?'+queryString ;
    
  const variation = props.swatchesVariation[key];
  if (!variation) {
  return null;
}


 const variation_price_data = variation?.variation_price_data;


  let parsedVariationPriceData;
  try {
    parsedVariationPriceData = variation_price_data ? JSON.parse(variation_price_data) : {};
  } catch (error) {
    parsedVariationPriceData = {};
  }

  //console.log('--- parsedVariationPriceData',parsedVariationPriceData)
  const termIDs =
  parsedVariationPriceData?.term_ids &&
  Array.isArray(parsedVariationPriceData.term_ids)
    ? parsedVariationPriceData.term_ids.join(',')
    : '';

  const calculatedPrice = calculatorPriceCustomise2(
  parsedVariationPriceData, 
  termIDs,
  props.customiseOption.topup_data,
  props.customiseOption.material_data, 
  props.customiseOption.multiplier_data
  );

  const priceDataCustomise = {
    regular_price: calculatedPrice?.regular_price || '',
    short_term_price: calculatedPrice?.short_term_price || '',
    sale_price: calculatedPrice?.sale_price || '',
    short_term_dates: props.item?.saleSchedule?._short_term_dates || {},
    sale_price_dates: props.item?.saleSchedule._sale_price_dates || {},
  }

  const dataCustomnise = { ...getPriceDataCustomise(priceDataCustomise), gallery: variation.gallery ? variation.gallery : props.item?.cover?.src, alt: variation.alt ? variation.alt : props.item?.cover?.alt };
  return dataCustomnise || null;
};
const handleSwatchClick = (event: Event, itemSlug: string, termId: string, swatchSlug: string, name: string) => {
  event.stopPropagation();
  event.preventDefault();
  
  // Update the selected attribute
  selectedIds.value[swatchSlug] = termId;
  arrayParam.value[swatchSlug] = itemSlug;
  nameGemstone.value = name;
  
  // Auto-select first items for other attributes that haven't been selected yet
  if (props.customiseAtribute) {
    // Process color swatches
    if (props.customiseAtribute.color_swatches) {
      Object.entries(props.customiseAtribute.color_swatches).forEach(([key, swatch]) => {
        if (!selectedIds.value[swatch.slug] && swatch.items && Object.keys(swatch.items).length > 0) {
          // Get the first item after sorting
          const sortedItems = getSortedItems(swatch.items);
          if (sortedItems.length > 0) {
            const firstItem = sortedItems[0];
            selectedIds.value[swatch.slug] = firstItem.att_term_id;
            arrayParam.value[swatch.slug] = firstItem.slug;
          }
        }
      });
    }
    
    // Process other swatches
    if (props.customiseAtribute.other_swatches) {
      Object.entries(props.customiseAtribute.other_swatches).forEach(([key, swatch]) => {
        if (!selectedIds.value[swatch.slug] && swatch.items && Object.keys(swatch.items).length > 0) {
          // Get the first item after sorting
          const sortedItems = getSortedItems(swatch.items);
          if (sortedItems.length > 0) {
            const firstItem = sortedItems[0];
            selectedIds.value[swatch.slug] = firstItem.att_term_id;
            arrayParam.value[swatch.slug] = firstItem.slug;
          }
        }
      });
    }
  }
  
  // Check if all attributes are now selected
  const lengthSelected = Object.keys(selectedIds.value).length;
  const lengthAllAttribute = 
    (props.customiseAtribute.color_swatches ? Object.keys(props.customiseAtribute.color_swatches).length : 0) + 
    (props.customiseAtribute.other_swatches ? Object.keys(props.customiseAtribute.other_swatches).length : 0);
  
  // Find and set the variation if all attributes are selected
  if (lengthSelected >= lengthAllAttribute) {
    selectedVariation.value = findVariation();
  }
};

const handleSwatchClick2222 = (event: Event , itemSlug: string, termId: string , swatchSlug:string , name : string) => {
  event.stopPropagation();
  event.preventDefault();

  selectedIds.value[swatchSlug] = termId;  
  arrayParam.value[swatchSlug] = itemSlug;
  nameGemstone.value = name ;

  const lengthSelected = Object.keys(selectedIds.value).length;
  const lengthAllAttribute = Object.keys(props.customiseAtribute).length;
  if (lengthSelected == lengthAllAttribute) {
    selectedVariation.value = findVariation();
  } else {
    if (lengthSelected < lengthAllAttribute) {
    }
  }

  
  
};

interface IItem {
    slug: string;      
    name: string;        
    thumb: string;      
    att_term_id: string; 
}
interface ICustomiseAttribute {
  color_swatches?: {
    [key: string]: {
      name: string;
      id: string;
      slug: string;
      items: {
        [key: string]: IItem
      }
    }
  };
  other_swatches?: {
    [key: string]: {
      name: string;
      id: string;
      slug: string;
      items: {
        [key: string]: IItem
      }
    }
  };
}
onMounted(() => {


    //Get the id based on minprice to activate the label :
   let idColor:string , idOther:string ;
    // if (props.customiseAtribute?.other_swatches &&  Object.keys(props.customiseAtribute?.other_swatches).length > 0) {

    //   Object.values(props.customiseAtribute.other_swatches).forEach(swatch => {
    //       if (swatch.items && Object.keys(swatch.items).length > 0) {
            
    //         if(idOther){
    //             const foundItem2  = Object.values(swatch.items).find(item => item.att_term_id.toString() === idOther.toString())  as IItem; 
    //             selectedIds.value[swatch.slug] = foundItem2.att_term_id;
    //             arrayParam.value[swatch.slug] = foundItem2.slug;
    //             nameGemstone.value = foundItem2.name ;

    //             if (paramString.value) paramString.value += '&';
    //               paramString.value += swatch.slug + `=${foundItem2.slug}`;

    //           } else {

    //             const firstItem = Object.values(swatch.items)[0];
    //             selectedIds.value[swatch.slug] = firstItem.att_term_id;
    //             arrayParam.value[swatch.slug] = firstItem.slug;
    //             nameGemstone.value = firstItem.name ;

    //             if (paramString.value) paramString.value += '&';
    //             paramString.value += swatch.slug + `=${firstItem.slug}`;

    //         }

    //       }

    //   });
    // }

    // selectedVariation.value = findVariation();     
    // salePrice.value = selectedVariation.value?.sale_price ;
    // regularPrice.value = selectedVariation.value?.regular_price ;
    // currentCover.value = selectedVariation.value?.gallery ;
    // altImage.value = selectedVariation.value?.alt ;

    
    

  let wishlistKey = userStore.isLogin ? 'all_item_wishlist' : 'list_wishlist';
  let wishlistData = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
  list_item_wishlist.value = wishlistData;

});
background_color.value = props.background_item;

</script>
<style scoped lang="scss">
@import "@/assets/scss/components/listing/listingItem.scss";
:deep(.customise_tag_detail){
      background: #ffeee6;
      color: #c60c46;
      font-size: 14px;
      padding: 5px 8px;
      text-transform: capitalize;
      font-weight: 500;
      display: inline-block;
      line-height: 1;
      margin-bottom: 3px;
}

      
</style>